import React from 'react';

function DemoBlockModal({ onClose }) {
  return (
    <div className="demo-block-overlay" onClick={onClose}>
      <div className="demo-block-modal" onClick={e => e.stopPropagation()}>
        <div className="demo-block-icon">🔒</div>
        <h3>Download Not Available</h3>
        <p>
          CSV downloads are not available for demo accounts.<br />
          Please contact <strong>support@sdcorner.com</strong> to get full access.
        </p>
        <button className="demo-block-close" onClick={onClose}>Got it</button>
      </div>
    </div>
  );
}

export default DemoBlockModal;
